import React from 'react';
import '../Events/event.css';
import image from '../Events/Pharmacist Day.png';
import img from '../../Components/Images/image.webp';
import img1 from '../../Components/Images/image1.webp';
import img2 from '../../Components/Images/image2.webp';
import img3 from '../../Components/Images/image3.webp';
import img4 from '../../Components/Images/image4.webp';
import img5 from '../../Components/Images/image5.webp';
import Gallery from '../Gallery/gallery';

const Pharmacist = () => {
    const images = [
        {
            src: img,
            alt: "Image"
        },
        {
            src: img1,
            alt: "Image"
        }, {
            src: img2,
            alt: "Image"
        }, {
            src: img3,
            alt: "Image"
        }, {
            src: img4,
            alt: "Image"
        }, {
            src: img5,
            alt: "Image"
        },

    ]
    return (
        <>
            <section className="about">
                <div className="main">
                    <img src={image} alt="About Us" />
                    <div className="all-text">
                        <h1>Pharmacist Day</h1>
                        <p>
                            Pharmacist Day, a dynamic and engaging event, unfolded as a celebration and educational platform addressing crucial healthcare topics. The festivities commenced with two impactful skits performed by students from the School of Health Sciences and Technology (SOHST), shining a spotlight on the vital theme of organ donation. These performances not only captivated the audience but also effectively conveyed the importance of contributing to this noble cause.
                            Building on the momentum, a quiz competition centered around organ donation was conducted, challenging participants' knowledge and fostering awareness on this critical aspect of healthcare. The event further delved into stimulating discussions with a thought-provoking debate on "Next-Gen Healthcare Systems in India." This encouraged participants to contemplate and exchange ideas on the future trajectory of healthcare in the country, contributing to a deeper understanding of the subject.
                        </p>
                        <p>
                            To infuse creativity into the event, various competitions, including poster making, model making, rangoli, and face painting, were organized. These contests provided students with a platform to showcase their artistic talents, adding a colorful and expressive dimension to the celebration.
                            The Nutrition and Dietetics department actively participated by setting up food stalls, offering not only delicious but also nutritious offerings. This initiative emphasized the importance of healthy eating habits, aligning with the broader theme of promoting overall well-being.
                        </p>
                        <p>
                            Adding prestige to the event, Dr. Dhan Singh Rawat, Cabinet Minister of Health and Higher Education in the Uttarakhand State Government, graced the occasion as the Chief Guest. Dr. Farooq, President of Himalayas Wellness Company, attended as the Guest of Honour. Both dignitaries addressed the students and faculty, delivering inspirational and motivational messages that resonated with the audience, further emphasizing the importance of healthcare in society.
                            The event reached its conclusion with an award distribution ceremony, where outstanding participants were acknowledged for their contributions. The Dean expressed gratitude in a heartfelt vote of thanks, underscoring the success of Pharmacist Day in seamlessly combining education, creative expression, and community engagement. Through its diverse activities and distinguished guests, Pharmacist Day emerged as a comprehensive platform to highlight essential healthcare topics and their profound significance in shaping a healthier society.
                        </p>
                    </div>
                </div>
            </section>
            <Gallery images={images} />
        </>
    );
};

export default Pharmacist;
